module.exports = __webpack_public_path__ + "img/page_recargate_slider_03.5c113fc1.png";